let $header: JQuery;
let $footer: JQuery;

let $wrapperContainer: JQuery;
let $videoImagePreloader: JQuery;
let $video: JQuery<HTMLVideoElement>;

const DEFAULT_VIDEO_WIDTH = 1920;
const DEFAULT_VIDEO_HEIGHT = 1080;

export function calcBackground() {
    const windowInnerWidth = window.innerWidth;
    const windowInnerHeight = window.innerHeight;

    if (windowInnerWidth === 0 || windowInnerHeight === 0) {
        setTimeout(calcBackground, 100);
        return;
    }

    resizeIndexWrapper();
    resizeVideoBackground();
    resizeImagePreloader();
}

function resizeVideoBackground() {
    const windowInnerWidth = window.innerWidth;
    const windowInnerHeight = window.innerHeight;
    let videoContainerHeight;

    const headerOuterHeight = $header.length && $header.outerHeight() || 0;
    if (getIsSeoIndex()) {
        videoContainerHeight = windowInnerHeight - headerOuterHeight;
    } else {
        const footerHeight = $footer.length ? ($footer.css('position') === 'absolute' ? 1 : $footer.outerHeight()) : 0;
        if (footerHeight === undefined) {
            throw new Error('footerHeight is undefined');
        }
        videoContainerHeight = windowInnerHeight - headerOuterHeight - footerHeight;
    }
    const devSignOuterHeight = $('#if_dev').outerHeight();
    if (devSignOuterHeight) {
        videoContainerHeight -= devSignOuterHeight;
    }
    videoContainerHeight -= parseInt($wrapperContainer.css('border-bottom-width') ?? '0');


    const originalVideoHeight = $video?.length
        ? $video?.get(0)?.videoHeight ?? DEFAULT_VIDEO_HEIGHT
        : DEFAULT_VIDEO_HEIGHT;
    const originalVideoWidth = $video?.length
        ? $video?.get(0)?.videoWidth ?? DEFAULT_VIDEO_HEIGHT
        : DEFAULT_VIDEO_WIDTH;

    if (originalVideoHeight == 0 || originalVideoWidth == 0) {
        return;
    }

    const scaleFullWidth = shouldScaleFullWidth({
        originalWidth: originalVideoWidth,
        originalHeight: originalVideoHeight,
        targetWidth: windowInnerWidth,
        targetHeight: videoContainerHeight
    });

    if (scaleFullWidth) {
        $videoImagePreloader.css({
            width: '100%',
            height: 'auto'
        });
        $video.css({
            width: '100%',
            height: 'auto'
        });
    } else {
        $videoImagePreloader.css({
            width: 'auto',
            height: '100%'
        });
        $video.css({
            width: 'auto',
            height: '100%'
        });
    }
}

function getIsSeoIndex(): boolean {
    return (!window.app.isSite1 && window.app.config.language === 'en' && !window.app.isLanding);
}

function resizeIndexWrapper() {
    let wrapperHeight = window.innerHeight;
    const headerOuterHeight = $header.length && $header.outerHeight() || 0;

    if ($wrapperContainer.css('position') !== 'absolute') {
        wrapperHeight -= headerOuterHeight;
    }
    const footerOuterHeight = $footer.outerHeight();
    if (footerOuterHeight !== undefined && $footer.css('position') !== 'absolute' && !getIsSeoIndex()) {
        wrapperHeight -= footerOuterHeight + 1;
    }

    const devSignOuterHeight = $('#if_dev').outerHeight();
    if (devSignOuterHeight) {
        wrapperHeight -= devSignOuterHeight;
    }
    wrapperHeight -= parseInt($wrapperContainer.css('border-bottom-width') ?? '0');

    $wrapperContainer.css({
        height: wrapperHeight
    });
}

export function resizeImagePreloader() {
    const $wrapperContainer = $('#index_wrapper');
    const imagePreloader = $wrapperContainer.find('.index_preloader');

    const imageHeight = imagePreloader.height();
    const imageWidth = imagePreloader.width();

    const wrapperHeight = $wrapperContainer.height();
    const wrapperWidth = $wrapperContainer.width();

    if (imageHeight === undefined ||
        imageWidth === undefined ||
        wrapperHeight === undefined ||
        wrapperWidth === undefined
    ) {
        // it's called when there is no image to resize, and it's ok :(
        return;
    }

    const widthScaleFactor = wrapperWidth / imageWidth;
    const heightScaleFactor = wrapperHeight / imageHeight;

    const factor = Math.max(...[widthScaleFactor, heightScaleFactor]);

    imagePreloader
        .width(imageWidth * factor)
        .height(imageHeight * factor);
}

type CalcOptions = {
    targetWidth: number,
    targetHeight: number,
    originalWidth: number,
    originalHeight: number
};

function shouldScaleFullWidth(options: CalcOptions) {
    const originalWidth = options.originalWidth;
    const originalHeight = options.originalHeight;
    const targetHeight = options.targetHeight;
    const targetWidth = options.targetWidth;
    let resultHeight: number;


    const scaleFactor = targetWidth / originalWidth;
    resultHeight = originalHeight * scaleFactor;

    return resultHeight >= targetHeight;
}

function setCarouselHeight() {
    const $carousel = $('#carousel');
    const height = $('.slide', $carousel).height();
    if (height === undefined) {
        return; // it's ok :(
    }
    $carousel.height(height);
}

export function onReadyCalcBack() {
    $header = $('#header');
    $footer = $('#footer');
    $wrapperContainer = $('#index_wrapper');
    $videoImagePreloader = $('#index_preloader');
    $video = $('.index_video');

    if (!window.app.isLanding) {
        // $regpopup = $('#registration');
        calcBackground();
        $(window).on('resize', function() {
            setTimeout(calcBackground, 200);
        });
    } else {
        setCarouselHeight();
        $(window).on('resize', setCarouselHeight);
        $(window).on('focus', setCarouselHeight);
    }
}

